import { ApolloClient } from '@apollo/client';

import { AssetExtractor } from '@finley-technologies/tape-sanitizer';

import {
  GetAssetAnalysisQueryGQLType,
  GetAssetAnalysisQueryVariablesGQLType,
  GetAssetAnalysisDocumentGQLType,
} from 'packages/tapeBuilder/requests/tapeBuilder.gql.generated';

export const getAssetExtractor = (
  apolloClient: ApolloClient<object>,
  pipelineDefinitionId: string,
): AssetExtractor.AssetExtractor => {
  return async (params: AssetExtractor.AssetExtractorParams) => {
    const serializedParams = AssetExtractor.serializeParams(params);
    const { data } = await apolloClient.query<
      GetAssetAnalysisQueryGQLType,
      GetAssetAnalysisQueryVariablesGQLType
    >({
      query: GetAssetAnalysisDocumentGQLType,
      variables: {
        params: serializedParams,
        pipelineDefinitionId,
      },
    });

    if (!data.result) {
      throw new Error('Asset extraction failed');
    }
    const output = AssetExtractor.deserializeOutput(data.result);
    return output;
  };
};
